/* eslint-disable react-hooks/exhaustive-deps */
import { useAddTrayContext } from '../AddTray.context'
import { useSubTraysContext } from '../SubTrays/SubTrays.context'
import { useSPD } from 'views/SPDLayout/SPD/SPD.context'
import { useEffect, useState } from 'react'
import { enqueueSnackbar } from 'notistack'

const useTrayContentLogic = (trayIndex: number) => {
  const { subTrays, setSubTrays, hasSubTrays } = useAddTrayContext()
  const { setCurrentView } = useSubTraysContext()
  const {
    setTrayScrews,
    setTrayPlates,
    trayScrews,
    trayPlates,
    otherItems,
    setOtherItems,
    customImplants,
    setCustomImplants,
  } = useSPD()

  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [isCustomImplantModalOpen, setIsCustomImplantModalOpen] =
    useState(false)

  const subTray = subTrays[trayIndex]
  const isInstrumentTray = subTray?.isInstrumentTray
  const traySubTrayTitle = hasSubTrays ? 'Sub Tray' : 'Tray'
  const isCustomImplantTray = subTray?.trayType === 'custom implants'

  useEffect(() => {
    if (subTray?.content) {
      setTrayScrews(subTray.content.screws || [])
      setTrayPlates(subTray.content.plates || [])
      setOtherItems(subTray.content.otherItems || [])
      setCustomImplants(subTray.content.customImplants || [])
    } else {
      setTrayScrews([])
      setTrayPlates([])
      setOtherItems([])
      setCustomImplants([])
    }
  }, [subTray, setTrayScrews, setTrayPlates, setOtherItems, setCustomImplants])

  const saveChanges = () => {
    if (subTray) {
      const updatedSubTrays = [...subTrays]
      updatedSubTrays[trayIndex] = {
        ...subTray,
        content: {
          ...subTray.content,
          screws: trayScrews,
          plates: trayPlates,
          otherItems,
          customImplants,
        },
      }
      setSubTrays(updatedSubTrays)

      enqueueSnackbar('Sub tray updated successfully', { variant: 'success' })
    }
  }

  const handleBack = () => {
    const isSaved =
      subTray?.content?.screws === trayScrews &&
      subTray?.content?.plates === trayPlates &&
      subTray?.content?.otherItems === otherItems &&
      subTray?.content?.customImplants === customImplants

    if (!isSaved) {
      setShowConfirmModal(true)
      return
    }

    navigateBack()
  }

  const navigateBack = () => {
    setTrayScrews([])
    setTrayPlates([])
    setCustomImplants([])
    setCurrentView('list')
  }

  const handleCustomImplantModalTrigger = () => {
    setIsCustomImplantModalOpen((prev) => !prev)
  }

  return {
    subTray,
    handleBack,
    saveChanges,
    showConfirmModal,
    setShowConfirmModal,
    navigateBack,
    isInstrumentTray,
    traySubTrayTitle,
    otherItems,
    setOtherItems,
    isCustomImplantTray,
    handleCustomImplantModalTrigger,
    isCustomImplantModalOpen,
  }
}

export default useTrayContentLogic
